<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="procedimentoListaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Procedimentos: {{ dados ? dados.search : 'Carregando...' }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!procedimentos || !procedimentos.length" msg="Nenhum procedimento identificado." />

                        <div v-else>
                            <az-input
                                type="checkbox-group"
                                label="TODOS"
                                v-model="todos" />

                            <div v-for="(procedimento, idx) in procedimentos" :key="idx">
                                <az-input 
                                    type="checkbox-group"
                                    :label="procedimento.search"
                                    v-model="procedimento.fl_pag_online" />
                            </div>
                        </div>

                        <pre v-if="1 == 0" class="alert alert-info">{{ procedimentos }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            dados: null,
            procedimentos: [], 
        }
    },

    components: { 
        AzInput,
        AzSubmit,
        AzEmptyState
    },

    computed: { 
        todos: { 
            get() {
                return this.procedimentos.findIndex(item => !item.fl_pag_online) < 0;
            },
            set(value) {
                this.procedimentos.forEach(element => {
                    element.fl_pag_online = value;
                });
            }
        }
    },

    methods: { 
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'procedimentos',
                func: 'stores_pag',
                dados: { 
                    procedimentos: this.procedimentos
                },
                modal: 'procedimentoListaModal',
                callback: () => { 
                    this.$emit('refresh');
                } 
            });
        },

        abrir() { 
            this.load();

            $('#procedimentoListaModal').modal('show');
        },
        load() { 

            this.dados = [];
            this.procedimentos = [];
            
            this.$store.commit("loading", true);

            let query = {
                q: [
                    {
                        name: 'procedimentos.index',
                        id: "procedimentos",
                        parms: {
                            agenda: true, 
                        }
                    }
                ]
            };

            return this.axios.post("/aql", query)
                .then(res => {
                    if (res.data.procedimentos.status == 200) {
                        this.procedimentos = res.data.procedimentos.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit("loading", false);
                });

        }
    }
}
</script>